import { render, staticRenderFns } from "./PortadaBgi.vue?vue&type=template&id=3c43eee2&"
import script from "./PortadaBgi.vue?vue&type=script&lang=js&"
export * from "./PortadaBgi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports